import { baseCrudFactory } from "~/stores/base.crud.store.ts"
import { useAuthStore } from "~/stores"
import { groupById } from "~/helpers"
import { PersonnelModel } from "~/model"

export const usePersonnelStore = baseCrudFactory({
    endpoint: "personnels",
    primaryKey: "IDPERSONNEL",
    title: "personnel",
    model: PersonnelModel,
    getters: {
        authStore() {
            return useAuthStore()
        },
        commerciaux() {
            return this.items
                .filter((personnel) => {
                    return (
                        personnel.ROLES?.includes("commercial") &&
                        personnel.IDCOMPANY ===
                            this.authStore.mainToken.company_id
                    )
                })
                .sort((a, b) => a.PRENOM.localeCompare(b.PRENOM))
        },
        commerciauxInStats() {
            return this.items
                .filter(
                    (personnel) =>
                        personnel.ROLES?.includes("commercial") &&
                        personnel.IDCOMPANY ===
                            this.authStore.mainToken.company_id &&
                        !personnel.HORS_STATS,
                )
                .sort((a, b) => a.PRENOM.localeCompare(b.PRENOM))
        },
        techniciens() {
            return this.items
                .filter((personnel) => {
                    return (
                        personnel.ROLES?.includes("technician") &&
                        personnel.IDCOMPANY ===
                            this.authStore.mainToken.company_id
                    )
                })
                .sort((a, b) => a.PRENOM.localeCompare(b.PRENOM))
        },
        itemsByCompanyId() {
            const items = this.items.filter((item) => {
                return item.MAIL !== null && item.ROLES?.length > 0
            })

            return groupById(items, "IDCOMPANY")
        },
    },
    actions: {
        sendInstallationEmail(personnelId: number, email?: string) {
            return this.api.personnel.personnelSendInstallationMail(
                personnelId,
                email,
            )
        },
        revokeTokens(personnelId: number) {
            return this.api.personnel.personnelRevokeTokens(String(personnelId))
        },
    },
})
